// extracted by mini-css-extract-plugin
export default {"searchContainer":"SearchBox_searchContainer__NB3SY"};